import Headroom from 'headroom.js';

const headroom = (bannerSelector = '.banner') => {
  $(document.body).on('beforeRun.ag.handler', () => {
    const $banner = $(bannerSelector);
    if ($banner.length) {
      const headroom = new Headroom($banner.get(0));
      headroom.init();
      // Freeze headroom since we're using fullpage.js
      headroom.freeze();
    }
  });
};

export default headroom;
